import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS, IProcessedJobApplication } from 'shared-lib'

@Injectable({providedIn: 'root'})
export class CandidateApplicationRepository extends CollectionRepository<IProcessedJobApplication> {
  protected COLLECTION = COLLECTIONS.CANDIDATE_APPLICATION
}
